import { SuperPageDetailValues, SuperPageServices } from "@/services/bedrock/SuperPageServices";
import { useClearVideoPageCache } from "@/utils";
import * as React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { SuperPageDetailsForm } from ".";
import { useEffect } from "react";
import { isCustomCTAType, normalizeCTA, SuperPage } from "@/services/bedrock";
import { toast } from "sonner";

interface Props {
  superPage: SuperPage;
  onSubmittingChange: (submitting: boolean) => void;
  onSuperPageUpdated: (updatedSuperPage: SuperPage) => Promise<void>;
}

const SuperPageUpdateDetailsForm: React.FC<Props> = ({ superPage, onSubmittingChange, onSuperPageUpdated }) => {
  const { clearVideoPageCache } = useClearVideoPageCache();
  const methods = useForm<SuperPageDetailValues>({
    defaultValues: {
      id: null,
      title: "",
      pageTitle: "",
      categories: [],
      videoScript: null,
      originalMedia: null,
      allowCtaChange: false,
      allowThemeChange: false,
      callToAction: null,
      contentPageTheme: null,
    },
  });
  const {
    handleSubmit,
    formState: { isSubmitting, dirtyFields },
    reset,
  } = methods;

  useEffect(() => {
    onSubmittingChange(isSubmitting);
  }, [isSubmitting, onSubmittingChange]);

  useEffect(() => {
    reset({
      ...superPage,
      callToAction: normalizeCTA(superPage.callToAction),
    });
  }, [superPage, reset]);

  const handleSaveSubmit = (form: SuperPageDetailValues) => {
    if (!superPage?.id) return;

    const changes = Object.fromEntries(
      Object.entries(form).filter(([key, _]) => dirtyFields[key as keyof SuperPageDetailValues])
    ) as Partial<SuperPageDetailValues>;

    if (changes.callToAction?.type && !isCustomCTAType(changes.callToAction.type)) {
      changes.callToAction.customLink = null;
    }
    return SuperPageServices.updateSuperPage(superPage.id, changes)
      .then(onSuperPageUpdated)
      .then(() => {
        toast.success("Super Page updated successfully");
        clearVideoPageCache({ superPages: true });
      })
      .catch(error => {
        console.log(error);
        toast.error("Error updating Super Page");
      });
  };

  return (
    <FormProvider {...methods}>
      {superPage && (
        <form onSubmit={handleSubmit(handleSaveSubmit)} className="flex flex-col gap-6">
          <SuperPageDetailsForm />
        </form>
      )}
    </FormProvider>
  );
};

export { SuperPageUpdateDetailsForm };
